import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { SingletonRequest } from 'shared/api/lib'
import { type IResponsePermissions, PermissionsApi } from '../api'

export class PermissionsStore {
  private _permissions: IResponsePermissions | null = null
  private _loading = true

  constructor() {
    makeAutoObservable(this)
  }

  get loading() {
    return this._loading
  }

  get isEmpty() {
    return !this._permissions
  }

  get permissions() {
    return this._permissions
  }

  get adminPermissions() {
    return this._permissions?.admin
  }

  get managerPermissions() {
    return this._permissions?.manager
  }

  get memberPermissions() {
    return this._permissions?.member
  }

  get viewOnlyPermissions() {
    return this._permissions?.view_only
  }

  private _init = async () => {
    if (!this.isEmpty) return

    try {
      runInAction(() => {
        this._loading = true
      })

      const { data } = await PermissionsApi.getPermissions()

      runInAction(() => {
        if (data) this._permissions = data
      })
    } catch (error) {
      logger.error(error)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  init = new SingletonRequest(this._init).request

  reset = () => {
    this._permissions = null
    this._loading = false
  }
}
